import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { FormGroup, Input, Label } from 'reactstrap';
import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';
// important: this line must be placed after react-table css import
import 'react-table-hoc-fixed-columns/lib/styles.css';

import Pagination from '../diy-utils/Pagination';
import RealizedPricesTableColumns from './RealizedPricesTableColumns';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const RealizedPricesTable = (props) => {
  const {
    currentPage,
    editLot,
    handleCheckbox,
    handleCheckboxAll,
    handleErrorCheckboxFilter,
    handleModal,
    handlePageClick,
    handlePageSize,
    itemsPerPage,
    lots,
    selectedLots,
    showOnlyErrors,
    spreadsheetErrors
  } = props;

  const lotsWithErrors = lots.filter(lot => lot.hasError);

  const numLots = showOnlyErrors ? lotsWithErrors.length : lots.length;
  const numPages = Math.ceil(numLots / itemsPerPage);

  return (
    <Fragment>
      <FormGroup className="pb-1" check>
        <Label for="showOnlyErrors" check>
          <Input
            className={lotsWithErrors.length === 0 ? 'mr-1 cursor-not-allowed' : 'mr-1'}
            disabled={lotsWithErrors.length === 0}
            id="showOnlyErrors"
            type="checkbox"
            checked={showOnlyErrors}
            onChange={handleErrorCheckboxFilter}
          />
          <p>View Items with errors</p>
        </Label>

        <span className="float-right ml-2">
          <Input type="select" value={itemsPerPage} onChange={e => handlePageSize(e)}>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </Input>
        </span>

        <span className="float-right my-1">Per page:</span>
      </FormGroup>

      <ReactTableFixedColumns
        minRows={1}
        data={showOnlyErrors ? lotsWithErrors : lots}
        defaultPageSize={20}
        page={currentPage}
        pageSize={itemsPerPage}
        columns={RealizedPricesTableColumns(
          handleModal,
          editLot,
          handleCheckbox,
          handleCheckboxAll,
          selectedLots,
          spreadsheetErrors
        )}
        showPagination={false}
        className="-highlight mb-3"
      />
      <Pagination
        handlePageClick={handlePageClick}
        numPages={numPages}
        currentPage={currentPage}
      />
    </Fragment>
  );
};

export default withRouter(RealizedPricesTable);
